export const SCORING_URL = 'https://www.sravni.ru/kredity/scoring/';
